import React from 'react';

export default function TextLink({ href, children, target, ...props }) {
  let linkProps = {
    ...props,
  };
  if (target === '_blank') {
    linkProps = {
      ...linkProps,
      rel: 'noopener noreferrer',
    };
  }
  return (
    <a href={href} target={target} {...linkProps}>
      {children}
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/components/elements/TextLink/index.js